import { Injectable } from '@angular/core'
import { ActivatedRoute, ParamMap, Params } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { getIdFromSlug } from '../shared/utility-functions/slug.utility'
import { RouterService } from './router.service'

@Injectable({ providedIn: 'root' })
export class SearchFiltersService {
  // TODO: We can likely remove the need for this behavior subject if we make our components react to changes in the
  // query params via some observable
  public readonly isFilterOrSearchLoading$ = new BehaviorSubject<boolean>(true)

  /**
   * Keep track of any changes to the "search" query param.
   */
  public searchParam: string | null = null
  public readonly searchQueryParam$ = this.routerService.queryParamMap$.pipe(
    map(queryParamMap => queryParamMap.get('search')),
    tap(searchParam => (this.searchParam = searchParam))
  )

  /**
   * Keep track of any changes to the "facets" query param.
   */
  public readonly facetsQueryParam$ = this.routerService.queryParamMap$.pipe(
    map(queryParamMap => queryParamMap.get('facets'))
  )

  /**
   * Keep track of any changes to the "offset" query param for pagination.
   */
  public readonly offsetParam$ = this.routerService.queryParamMap$.pipe(
    map(queryParamMap => queryParamMap.get('offset'))
  )

  constructor(private readonly routerService: RouterService) {}

  public getParamMap = (activatedRouteParent: ActivatedRoute | null): Observable<ParamMap> => {
    if (activatedRouteParent) return activatedRouteParent.paramMap
    else throw new Error('getParamMap: cannot get property of undefined')
  }

  public getNodeId = (params: ParamMap): number => {
    const slug = params.get('slug')
    const nodeId = !!slug ? getIdFromSlug(slug) : null

    if (!nodeId) throw new Error('getNodeId: cannot get NodeId')

    return nodeId
  }

  // TODO: Update to use ParamMap instead of params
  public updateQueryParams(params: Params) {
    this.isFilterOrSearchLoading$.next(true)
    this.routerService.updateQueryParams(params)
  }
}
